// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    text-align: start;
}

@media (max-width: 767px) {
    .LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF {
        font-size: 18px;
        line-height: 28px;
    }
}

/* Inferred (pre-filled) location summary + "Change" link — app-parity showServiceAddress. */

.LocationSearchForm-inferredLocationRow-gqyBE {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid #e2e2e2;
    border: 1px solid var(--border-color, #e2e2e2);
    border-radius: 10px;
    background: #fff;
    background: var(--card, #fff);
}

.LocationSearchForm-inferredLocationLabel-NT7J7 {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: var(--primary-foreground);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.LocationSearchForm-changeLocationLink-ZasAM {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    background: none;
    border: none;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    color: #e11d2a;
    color: var(--brand, #e11d2a);
    cursor: pointer;
    white-space: nowrap;
}

.LocationSearchForm-changeLocationLink-ZasAM:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewCategory/LocationSearchForm/LocationSearchForm.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,4FAA4F;;AAC5F;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,yBAA8C;IAA9C,8CAA8C;IAC9C,mBAAmB;IACnB,gBAA6B;IAA7B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,oBAAc;QAAd,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAA4B;IAA5B,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".viewCategoryHourlySearchHeading {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    text-align: start;\n}\n\n@media (max-width: 767px) {\n    .viewCategoryHourlySearchHeading {\n        font-size: 18px;\n        line-height: 28px;\n    }\n}\n\n/* Inferred (pre-filled) location summary + \"Change\" link — app-parity showServiceAddress. */\n.inferredLocationRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 14px;\n    border: 1px solid var(--border-color, #e2e2e2);\n    border-radius: 10px;\n    background: var(--card, #fff);\n}\n\n.inferredLocationLabel {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: var(--primary-foreground);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n.changeLocationLink {\n    flex-shrink: 0;\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--brand, #e11d2a);\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.changeLocationLink:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewCategoryHourlySearchHeading": `LocationSearchForm-viewCategoryHourlySearchHeading-ZKKRF`,
	"inferredLocationRow": `LocationSearchForm-inferredLocationRow-gqyBE`,
	"inferredLocationLabel": `LocationSearchForm-inferredLocationLabel-NT7J7`,
	"changeLocationLink": `LocationSearchForm-changeLocationLink-ZasAM`
};
module.exports = ___CSS_LOADER_EXPORT___;
